export default __webpack_public_path__ + "static/media/Background_00222.0a960564.png";